import Button$1 from './button.js';
import ButtonGroup from './group.js';
var Button = Button$1;
Button.Group = ButtonGroup;
export { Button as default };